import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { StoreModelService } from '../_services';
import * as StoreModelActions from '../_actions/storeModel';

@Injectable({
  providedIn: 'root',
})
export class StoreModelEffects {
  loadStoreModels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StoreModelActions.loadStoreModels),
      mergeMap(() =>
        this.storeModelService.getStoreModels().pipe(
          map((storeModels) => {
            return StoreModelActions.loadStoreModelsSuccess({ storeModels });
          }),
          catchError((error) => of(StoreModelActions.loadStoreModelsFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private storeModelService: StoreModelService
  ) {}
}
